import { Outlet } from 'react-router';

export const AuthLayout = (): React.ReactElement => (
  <div className="flex flex-col am-xl:min-h-screen">
    <Outlet />
  </div>
);
